<template>
<div class=notifications>
  <notificationsList></notificationsList>
</div>
</template>

<script>
import notificationsList from './notificationsList.vue'

export default {
  components: {
    notificationsList
  }
}
</script>
<style scoped>
.notifications {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/notifications/notifications.vue